import { render, staticRenderFns } from "./StaticFileDownloadButton.vue?vue&type=template&id=0032138c&scoped=true&"
import script from "./StaticFileDownloadButton.vue?vue&type=script&lang=js&"
export * from "./StaticFileDownloadButton.vue?vue&type=script&lang=js&"
import style0 from "./StaticFileDownloadButton.vue?vue&type=style&index=0&id=0032138c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0032138c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
